<template>
	<div class="w100p service-network">
		
		<div class="pd-t30 pd-b50">
			
			<div class="mg-b20">
				<img class="max-w100p" :src="publicPath + 'static/images/service-network/map.jpg'" alt="">
			</div>
			
			<div class="clear w100p mg-b20 mg-l-20 region-list">
				<div class="fl w25p mg-b20 pd-lr20 region-list-item" v-for="(item, index) in region.list">
					<div class="text-center w100p">
						<div class="pic">
							<img :src="item.pic" alt="">
						</div>
						<div class="f24 text">
							{{ item.title }}
						</div>
					</div>
				</div>
			</div>
			
			<div class="description">
				
				<div class="mg-b50">
					<div class="f20">
						已设立省级分支机构：
					</div>
					<div class="f16">
            <p>山西分公司（电话：18534605932）</p>
            <p>办公地址：山西省太原市晋源区金胜镇新晋祠路480号全景晋阳湖C座26层2607号</p>
						<p>青岛分公司（电话：18653167755）</p>
						<p>办公地址：山东省青岛市莱西市夏格庄镇梦鲤大街43-109-1号</p>
						<p>内蒙古分公司（电话：0471-6552657）</p>
						<p>办公地址：内蒙古自治区呼和浩特市经济技术开发区科尔沁南路69号呼和浩特留学人员创业园创新创业大厦主楼1111房间</p>
            <p>广东分公司（电话：15323631319）</p>
            <p>办公地址：珠海市拱北迎宾南路2230号4J房</p>
					</div>
				</div>
				
				<div class="mg-b20">
					<div class="f20">
						筹建中： 贵州分公司、江苏分公司
					</div>
					<div class="f16">
						<p>服务联系电话：400-004-8787</p>
					</div>
				</div>
				
			</div>
			
		</div>
		
	</div>
</template>

<script>
	export default {
		name: "service-network",
		
		data() {
			return {
				region: {
					list: [
						{ title: '广东', pic: '/static/images/service-network/list_item_01.png' },
						{ title: '青岛', pic: '/static/images/service-network/list_item_02.png' },
						{ title: '内蒙', pic: '/static/images/service-network/list_item_03.png' },
						{ title: '山西', pic: '/static/images/service-network/list_item_04.png' },
						// { title: '阳江', pic: '/static/images/service-network/list_item_05.png' },
						{ title: '江苏', pic: '/static/images/service-network/list_item_06.png' },
						{ title: '巴彦淖尔', pic: '/static/images/service-network/list_item_07.png' },
						{ title: '珠海', pic: '/static/images/service-network/list_item_08.png' },
						{ title: '贵州', pic: '/static/images/service-network/list_item_09.png' },
					]
				}
			}
		}
	}
</script>

<style>
	.service-network .description { color: #7a6a56; }
</style>